module.exports = __webpack_public_path__ + "img/succeed.4cad9391.png";